var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"empty-line",style:({height: _vm.props.height +'px',background: _vm.props.bgColor})})])}
var staticRenderFns = []

export { render, staticRenderFns }